'use strict';

var React = require('react');
require('prop-types');
var Delete = require('../node_modules/@material-ui/icons/Delete.js');
var Edit = require('../node_modules/@material-ui/icons/Edit.js');
var Grid = require('../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Tooltip = require('../node_modules/@material-ui/core/esm/Tooltip/Tooltip.js');
var IconButton = require('../node_modules/@material-ui/core/esm/IconButton/IconButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function EditAndDelete(_ref) {
  var canEdit = _ref.canEdit,
      canDelete = _ref.canDelete,
      editting = _ref.editting,
      onEditClick = _ref.onEditClick,
      onDeleteClick = _ref.onDeleteClick;
  return React__default["default"].createElement(Grid["default"], {
    container: true
  }, canEdit && !editting && React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Tooltip["default"], {
    title: "Edit",
    onClick: function onClick() {
      return onEditClick();
    }
  }, React__default["default"].createElement(IconButton["default"], null, React__default["default"].createElement(Edit, {
    color: "primary"
  })))), canDelete && React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Tooltip["default"], {
    title: "Delete",
    onClick: function onClick() {
      return onDeleteClick();
    }
  }, React__default["default"].createElement(IconButton["default"], null, React__default["default"].createElement(Delete, null)))));
}

EditAndDelete.defaultProps = {
  editting: false,
  canEdit: false,
  canDelete: false,
  onEditClick: function onEditClick() {},
  onDeleteClick: function onDeleteClick() {}
};

module.exports = EditAndDelete;
